<template>
  <div class="addTourist">
    <div class="box">
      <div class="title">游客</div>
      <div class="input-box">
        <span>姓名</span>
        <input maxlength="50" v-model.trim="name" type="text" placeholder="请输入姓名">
      </div>
      <div class="input-box item-box">
        <span>证件类型</span>
        <div class="container">
          <div @click="clickSwitch('id_card')" class="item" :class="{ 'currentTicket' : certType === 'id_card'}">身份证</div>
          <div @click="clickSwitch('passport')" class="item" :class="{ 'currentTicket' : certType === 'passport'}">护照</div>
          <div @click="clickSwitch('hkmo_id_card')" class="item" :class="{ 'currentTicket' : certType === 'hkmo_id_card'}">
            <div>港澳台</div>
            <div>通行证</div>
          </div>
          <div @click="clickSwitch('prc')" class="item" :class="{ 'currentTicket' : certType === 'prc'}">
            <div>外国人永久</div>
            <div>居留身份证</div>
          </div>
        </div>
      </div>
      <div class="input-box">
        <span>证件号码</span>
        <input v-model.trim="certNo" :maxlength="maxLengList[`${certType}`]" type="text" placeholder="请输入证件号码">
      </div>
      <!-- <div class="input-box">
        <span>电话号码</span>
        <input v-model.trim="mobile" type="tel" maxlength="11" placeholder="请输入电话号码">
      </div> -->
    </div>

    <ul class="tags">
      <li v-for="item in tagList" @click="changeTag(item)" :key="item.value">
        <img v-if="item.active" src="~@/assets/image/common/common_tick.png" alt="">
        <img v-else src="~@/assets/image/common/common_unchecked.png" alt="">
        <div class="describe">
          <div class="describe-title">{{ item.key }}</div>
          <div class="describe-text">{{ item.describe }}</div>
        </div>
      </li>
    </ul>
    <div class="selected">
      <div class="cancel" @click="cancel">取消</div>
      <div class="determine" @click="clickConfirm">确定</div>
    </div>
  </div>
</template>

<script>
import {
  getAddPerson,
  getUpdataPerson
  } from '@/service/oftencontact/oftenconaddTourist.js';

export default {
  name: "oftenconaddTourist",
  data(){
    return {
      name: '',
      certType: 'id_card',
      certNo: '',
      mobile: '',
      updataType: 'add',
      id: '',
      tagList: this.generateTagList(),
      updataOftenconaddTourist: null,
      maxLengList: {
        'id_card': process.env.VUE_APP_IDCARD_MAX_LENGTH,
        'passport': process.env.VUE_APP_PASSPORT_MAX_LENGTH,
        'hkmo_id_card': process.env.VUE_APP_HKMO_IDCARD_MAX_LENGTH,
        'prc': process.env.VUE_APP_PRC_MAX_LENGTH,
      },
    }
  },
  created(){
    this.defaultItem();
  },
  methods:{
    changeTag(item){
      this.tagList.forEach(v => v.active = false);
      item.active = true;
    },
    generateTagList(){
      return [
        {
          key: '学生',
          value: 'student',
          describe: '7~18岁及全日制本科以下学生',
          active: true,
        },
        {
          key: '成人',
          value: 'adult',
          describe: '18~59岁',
          active: false,
        },
      ]
    },
    defaultItem(){
      const updataOftenconaddTourist = JSON.parse(window.sessionStorage.getItem('userOftenconaddTouristItem'));
      if(updataOftenconaddTourist){
        this.name = updataOftenconaddTourist.name;
        this.certType = updataOftenconaddTourist.certType;
        this.certNo = updataOftenconaddTourist.certNo;
        this.mobile = updataOftenconaddTourist.mobile;
        this.id = updataOftenconaddTourist.id;
        this.updataType = 'modify';
        if(updataOftenconaddTourist.tag !== 'un_set'){
          this.$nextTick(() => {
            this.tagList.forEach(v => v.value === updataOftenconaddTourist.tag ? (v.active = true) : (v.active = false));
          });
        };
        this.updataOftenconaddTourist = updataOftenconaddTourist;
      }
    },
    async clickConfirm(){
      const updataType = this.updataType;
      const { idcardallowance, foreignnationalityallowance } = this.$route.query;
      if(updataType === 'add' || this.updataOftenconaddTourist.certType !== this.certType){
        if(this.certType === 'id_card' && parseInt(idcardallowance) >= process.env.VUE_APP_MAX_NUMBER_VISITORS){
          return this.$toast(`身份证常用游客上限${process.env.VUE_APP_MAX_NUMBER_VISITORS}人`)
        }else if(this.certType !== 'id_card' && parseInt(foreignnationalityallowance) >= process.env.VUE_APP_MAX_NUMBER_VISITORS){
          return this.$toast(`外籍常用游客上限${process.env.VUE_APP_MAX_NUMBER_VISITORS}人`);
        };
      };
      if(!this.name)return this.$toast('请输入姓名');
      // if(!this.$reg.checkName.test(this.name))return this.$toast('姓名请勿填写特殊字符');
      if(!this.certNo)return this.$toast('请输入证件号码');
      if(this.certType === 'id_card' && !this.$reg.checkIDCard(this.certNo))return this.$toast('身份证号错误');
      if(this.$reg.checkIDCard(this.certNo)){
        const age = this.$reg.checkAge(this.certNo)
        if(age < 7)return this.$toast('7周岁以下，无需购票');
        if(age >= 60)return this.$toast('60周岁以上，无需购票');
        this.certNo = this.certNo.toUpperCase();
      };
      if(this.certType === 'passport' && !this.$reg.checkPassportNo.test(this.certNo))return this.$toast('请输入正确的证件号');
      if(this.certType === 'hkmo_id_card' && !this.$reg.checkhkmTPassportNo.test(this.certNo))return this.$toast('请输入正确的证件号');
      if(this.certType === 'prc' && !this.$reg.checkNewPrcNo(this.certNo))return this.$toast('请输入正确的证件号');
      // if(!this.mobile)return this.$toast('请输入电话号码');
      // if(!this.$reg.checkPhone(this.mobile))return this.$toast('电话格式错误');
      let data;
      const parameter = {
          userId: JSON.parse(window.localStorage.getItem('userInfo')).userId,
          name: this.name,
          mobile: this.mobile,
          certNo: this.certNo,
          certType: this.certType,
          personType: 'traveller',
          certTypes: [this.certType],
          tag: this.tagList.find(v => v.active).value,
      }
      if(updataType === 'add'){
        data = await getAddPerson.call(this, parameter);
      }else{
        data = await getUpdataPerson.call(this, { ...parameter,  id: this.id});
      };
      if(data.status === "0"){
        const toastText = updataType === 'add' ? '添加成功' : '修改成功';
        this.$toast(toastText);
        setTimeout(() => {
          this.$router.push('/useroftencontactslist')
        }, 1500);
      };
    },
    changeTagList(){
      const checkAge = this.$reg.checkAge(this.certNo);
      if(checkAge >= 7 && checkAge <= 18){
        this.tagList[0].active = true;
        this.tagList.pop();
      };
      // 学生、成人可选
      if(checkAge > 18 && checkAge < 25){
        this.tagList[0].active = true;
      }
      // 成人
      if(checkAge >= 25 && checkAge < 60){
        this.tagList.shift();
        this.tagList[0].active = true;
      }
    },
    clickSwitch(certType){
      this.certType = certType;
      if(certType === 'id_card' && this.$reg.checkIDCard(this.certNo)){
        this.changeTagList();
      }else{
        this.tagList.splice(0, this.tagList.length);
        this.tagList.push(...this.generateTagList());
      }
    },
    cancel(){
      this.$router.push('/useroftencontactslist')
    }
  },
  watch: {
    certNo: {
      handler(newValue){
        if(this.certType !== 'id_card')return;
        if(!this.$reg.checkIDCard(newValue))return;
        this.tagList = this.generateTagList();
        this.changeTagList();
      },
      immediate: true,
      deep: true
    }
  },
};
</script>

<style scoped lang='less'>
.addTourist{
  min-height: 100vh;
  padding-bottom: 1.333333rem + .333333rem;
  white-space: nowrap;
}
.box{
  margin: .4rem .346667rem 0;
  background: #FFFFFF;
  border-radius: .16rem;
  padding: .346667rem;
  line-height: .666667rem;
  font-size: .373333rem;
  .title{
    font-size: .213333rem * 2;
    line-height: 1;
    padding-bottom: .066667rem;
  }
  .input-box{
    margin-top: .533333rem;
    display: flex;
    align-items: center;
    span{
      width: 4em;
      margin-right: .666667rem;
    }
    input{
      flex: 1;
    }
  }
  .item-box{
    span{
      height: 1.2rem;
      line-height: 1.2rem;
    }

    .container{
      flex: 1;
      display: flex;
      flex-wrap: wrap;
      .item{
        width: 2.266666rem;
        margin-right: 0.213333rem;
        flex-direction: column;
        border-radius: 0.16rem;
        font-size: .373333rem;
        height: 1.2rem;
        line-height: 0.5rem;
        display: flex;
        align-items: center;
        justify-content: center;
        border: 1px solid #B9BED1;
        text-align: center;
        white-space: pre-wrap;
        &:nth-child(3),
        &:last-child{
          margin-top: 0.213333rem;
        }
      }
      .currentTicket{
        background: #3B6D9C;
        color: #ffffff;
        border: none !important;
      }
    }
  }
}
.selected{
    position: fixed;
    bottom: 0.666667rem;
    display: flex;
    width: 100%;
    line-height: 1.333333rem;
    padding: 0 .4rem;
    div{
      flex: 1;
      border-radius: .16rem;
      text-align: center;
      font-size: .24rem * 2;
      color: #FFFFFF;
    }
    .cancel{
      background: #A1A6BA;
      margin-right: .32rem;
    }
    .determine{
      background: #3B6D9C;
    }
}
.tags{
  display: flex;
  padding: .4rem .733333rem;
  & > li{
    display: flex;
    margin-left: 1.533333rem;
    &:first-child{
      margin-left: 0;
    }
    img{
      width: .453333rem;
      height: .453333rem;
    };
    .describe{
      padding-left: .133333rem;
      .describe-title{
        width: .8rem;
        height: .373333rem;
        background: #F1F5F8;
        border-radius: .186667rem;
        font-size: .24rem;
        color: #3B6D9C;
        line-height: .373333rem;
        text-align: center;
        padding: 0 .16rem;
      }
      .describe-text{
        margin-top: .133333rem;
        font-size: .266667rem;
        color: #999999;
        line-height: .373333rem;
      }
    }
  }
}
</style>
